export default __webpack_public_path__ + "media/images/submit-right-92c62ca357c84449511bed4321012e47.png";